<template>
  <button class="nvx-btn" :class="{ 'nvx-btn-destructive': destructive }" :disabled="disabled" @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'SDCButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    destructive: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.nvx-btn {
  background: radial-gradient(135.75% 139.94% at 0% 50%, var(--color-button-from) 0%, var(--color-button-to) 43.64%);
  border: none;
  border-radius: 18px;
  padding: 18px;
  width: 100%;

  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: white;

  transition: transform 0.1s ease;

  &:active {
    transform: scale(0.92);
  }

  &:disabled {
    background: var(--color-disabled, #f0f0f0);
    color: #8c8c8c;

    @media (prefers-color-scheme: dark) {
      background: var(--color-disabled-dark, #1f1f1f);
    }
  }

  &-destructive:not(:disabled) {
    background: var(--color-destructive);
  }
}
</style>
